import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { onUnauthorized, SESSION_ENDED_STATE } from "./session";

/**
 * Top-level layout. Hosts [SessionExpiryHandler] (the client half of R7 revocation) and renders the
 * routed tree. Kept thin — per-venue chrome lives in [VenueShellLayout].
 */
export function AppLayout() {
  return (
    <>
      <SessionExpiryHandler />
      <Outlet />
    </>
  );
}

/**
 * On any 401 (a revoked / expired session — features/roles-and-permissions.md R7), clear the query
 * cache and route to /login. The QueryClient (created outside the router) signals via the `session`
 * pub-sub; this component owns `useNavigate`, so the sign-out stays an in-SPA navigation.
 */
function SessionExpiryHandler() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  useEffect(
    () =>
      onUnauthorized(() => {
        queryClient.clear();
        navigate("/login", { replace: true, state: SESSION_ENDED_STATE });
      }),
    [navigate, queryClient],
  );
  return null;
}
